var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOnlyTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 903,
    height: 80,
    viewBox: "0 0 903 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_968_126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.383 15.0362C345.087 12.2197 347.509 8.63425 349.484 5.78999C350.723 4.01117 353.369 4.01117 354.599 5.78999C356.574 8.62499 358.996 12.2197 360.7 15.0362C363.299 19.3257 382.723 52.5582 392.103 68.6417L393.817 72.5978C394.656 74.5248 393.389 76.6928 391.293 76.9522C389.979 77.1097 388.424 77.2209 386.691 77.2209H317.392C315.659 77.2209 314.104 77.1097 312.79 76.9522C310.694 76.702 309.427 74.5248 310.266 72.5978L311.98 68.6417C321.36 52.5582 340.784 19.3257 343.383 15.0362Z",
    fill: "url(#paint0_linear_968_126)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_968_126",
    x1: 351.924,
    y1: 57.7279,
    x2: 352.04,
    y2: 77.2209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59D00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_968_126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84.0829,
    height: 72.7557,
    fill: "white",
    transform: "translate(310.005 4.45587)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnlyTriangle);
export default __webpack_public_path__ + "static/media/logo_only_triangle.89d63179387ba2a3abeb292bb70c897d.svg";
export { ForwardRef as ReactComponent };